import { render, staticRenderFns } from "./RetentionSimulator.vue?vue&type=template&id=99529212"
import script from "./RetentionSimulator.vue?vue&type=script&lang=js"
export * from "./RetentionSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports